var _desc, _defs, _rect, _text, _text2, _rect2, _circle, _text3, _text4, _text5, _text6, _g, _text7, _text8, _line, _text9, _text0, _text1, _text10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealYieldCardMockup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 420,
    viewBox: "0 0 700 420",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "ry-title"
  }, "Real Yield \u2014 my covered-call book") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "ry-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "ry-desc"
  }, "About 40 percent of what the old math counted as income was phantom. Of $40,498 recorded as income, $18,069 was phantom stock gains and $22,429 was real kept income. Founder's own account, as of 9 June 2026 \u2014 one trader's history, not a projection.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "ry-phantom-hatch",
    width: 8,
    height: 8,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 8,
    stroke: "#1a1a1a",
    strokeOpacity: 0.28,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ry-real-grad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ry-shadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "125%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 14,
    floodColor: "#000000",
    floodOpacity: 0.45
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 668,
    height: 392,
    rx: 18,
    fill: "#1a1a1a",
    stroke: "#3a3a3a",
    strokeWidth: 1,
    filter: "url(#ry-shadow)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 58,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 20,
    fontWeight: 600,
    fill: "#ffffff"
  }, "Real Yield")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 80,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#999999"
  }, "my covered-call book")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 40,
    width: 140,
    height: 26,
    rx: 13,
    fill: "#252525",
    stroke: "#3a3a3a",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 53,
    r: 3.5,
    fill: "#2962ff"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 57,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#cccccc"
  }, "my account")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 138,
    fontFamily: "'JetBrains Mono', ui-monospace, monospace",
    fontSize: 56,
    fontWeight: 700,
    fill: "#EF4444"
  }, "~40%")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 166,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 16,
    fontWeight: 500,
    fill: "#ffffff"
  }, "of what the old math called &#8220;income&#8221; was phantom")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 187,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#999999"
  }, "stock gains the app was double-counting as yield")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 214,
    width: 273,
    height: 44,
    rx: 8,
    fill: "url(#ry-phantom-hatch)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 214,
    width: 273,
    height: 44,
    rx: 8,
    fill: "none",
    stroke: "#EF4444",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319,
    y: 214,
    width: 337,
    height: 44,
    rx: 8,
    fill: "url(#ry-real-grad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 235,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#ffffff",
    letterSpacing: 0.5
  }, "PHANTOM"), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 250,
    fontFamily: "'JetBrains Mono', ui-monospace, monospace",
    fontSize: 13,
    fontWeight: 700,
    fill: "#ffffff"
  }, "$18,069"), /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 235,
    textAnchor: "end",
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#ffffff",
    letterSpacing: 0.5
  }, "REAL INCOME"), /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 250,
    textAnchor: "end",
    fontFamily: "'JetBrains Mono', ui-monospace, monospace",
    fontSize: 13,
    fontWeight: 700,
    fill: "#ffffff"
  }, "$22,429"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 290,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#cccccc"
  }, "Old math called this&#160;&#160;\n    ", /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'JetBrains Mono', ui-monospace, monospace",
    fontWeight: 700,
    fill: "#ffffff"
  }, "$40,498"), "&#160;&#160;income.")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 312,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#cccccc"
  }, "I actually kept&#160;&#160;\n    ", /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'JetBrains Mono', ui-monospace, monospace",
    fontWeight: 700,
    fill: "#10B981"
  }, "$22,429"), ".")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 336,
    x2: 656,
    y2: 336,
    stroke: "#2a2a2a",
    strokeWidth: 1
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 360,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#aaaaaa"
  }, "my own account &#183; as of 9 Jun 2026 &#183; not a projection")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 380,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#777777"
  }, "Your numbers will differ \u2014 one trader&#8217;s history, not a guarantee.")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 396,
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 11,
    fontWeight: 400,
    fill: "#777777"
  }, "Marks are the official daily close; quiet contracts use prior close.")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 656,
    y: 394,
    textAnchor: "end",
    fontFamily: "'Geist', -apple-system, 'Segoe UI', sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#2962ff"
  }, "Babylon")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealYieldCardMockup);
export default __webpack_public_path__ + "static/media/real-yield-card-mockup.1e48b47bf5ed8683a49b0d7c2d9ec371.svg";
export { ForwardRef as ReactComponent };